export const GetURL = (endPoint) => {
  /**For local to run ng serve up server add below line
  return 'http://localhost.vanguard.com:8080/' + endPoint***/

  return `${document.baseURI}${endPoint}`
}
